import { ButtonSegment } from "components/SegmentedButton/types";
import { Application } from "models/Application";

export enum ApplicationPageTabs {
	DETAILS = "detalhes",
	ANALYSIS = "analises",
	DOCUMENTS = "documentos"
}

export type ApplicationDetailParams = {
	applicationId: string;
	selectedTab: ApplicationPageTabs;
};

export interface TabComponentProps {
	loading: boolean;
	application: Application | undefined;
	reloadApplication?: () => void;
	isBackoffice: boolean;
	isMobile?: boolean;
}
export interface TabContent extends ButtonSegment {
	component: (props: TabComponentProps) => JSX.Element;
}
